// Payslip delivery status and completion messages (no).
window.PlummeI18n.register('no', {
  'err.payslip.notAuthorized': 'Du har ikke tilgang til denne forespørselen om utsending.',
  'err.payslip.approvedRunRequired': 'Godkjenn lønnskjøringen før lønnsslippene legges i kø.',
  'err.payslip.queueTooLarge': 'Lønnsslippdataene er for store til å legges i kø. Kontakt brukerstøtte.',
  'pay.payslipSent': 'Lønnsslipp sendt.',
  'pay.payslipsSent': 'Lønnsslipper sendt.',
  'pay.payslipsSentAndPosted': 'Lønnsslipper sendt og lønn regnskapsført.',
  'pay.payslipsQueuedAndPosted': 'Lønn regnskapsført. Lønnsslipper lagt i utsendingskø.',
  'pay.payslipQueued': 'I kø for utsending',
  'pay.payslipsQueued': 'Lønnsslipper i utsendingskø.',
  'pay.payslipGenerated': 'Generert',
  'pay.payslipNotReady': 'Ikke klar',
  'pay.payslipScheduled': 'Planlagt',
});
